import { render } from "./initials_step.vue?vue&type=template&id=240218a7&scoped=true"
import script from "./initials_step.vue?vue&type=script&lang=js"
export * from "./initials_step.vue?vue&type=script&lang=js"

import "./initials_step.vue?vue&type=style&index=0&id=240218a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240218a7"]])

export default __exports__